class aBpGrid extends HTMLDivElement {
    constructor() {
        super();
        this.gridViewElement = document.querySelector('[is="a-bp-grid-view"]');
    }

    connectedCallback() {
        this.addEventListener('click', this.toggleGrid);
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.toggleGrid);
    }

    toggleGrid() {
        if (this.gridViewElement) {
            if (this.gridViewElement.hidden) {
                this.setAttribute('data-active', '');
                this.gridViewElement.removeAttribute('hidden');
            } else {
                this.removeAttribute('data-active');
                this.gridViewElement.setAttribute('hidden', 'hidden');
            }
        }
    }
}

customElements.define('a-bp-grid', aBpGrid, {
    extends: 'div'
});

